import React from 'react';
import type { ExpandRoute } from '@/routes/type';

const OrderDetailPage = React.lazy(() => import('./Detail'));
const TempOrderDetailPage = React.lazy(() => import('./TempDetail'));
const CartTempOrderDetailPage = React.lazy(() => import('./CartTempDetail'));
const OrderResultPage = React.lazy(() => import('./Result'));
const PreOrderResultPage = React.lazy(() => import('./PreResult'));
const DeliveryTempOrderDetailPage = React.lazy(
  () => import('./DeliveryTempDetail'),
);
const DeliveryOrderDetailPage = React.lazy(() => import('./DeliveryDetail'));
const DeliveryOrderResultPage = React.lazy(() => import('./DeliveryResult'));

export const OrderRoutes: ExpandRoute[] = [
  {
    path: 'order',
    children: [
      {
        path: ':id',
        element: <OrderDetailPage />,
        metas: {
          title: 'Order detail',
        },
      },
      {
        path: 'temp/:id',
        element: <TempOrderDetailPage />,
        metas: {
          title: 'Order detail',
        },
      },
      {
        path: 'cart/:id',
        element: <CartTempOrderDetailPage />,
        metas: {
          title: 'Order Detail',
        },
      },
      {
        path: 'result',
        element: <OrderResultPage />,
        metas: {
          title: 'Order Result',
        },
      },
      {
        path: 'pre-result',
        element: <PreOrderResultPage />,
        metas: {
          title: 'Pre Order Result',
        },
      },
      {
        path: 'delivery',
        metas: {
          title: 'Delivery Order Detail',
        },
        children: [
          {
            path: 'result',
            element: <DeliveryOrderResultPage />,
          },
          {
            path: 'temp/:id',
            element: <DeliveryTempOrderDetailPage />,
          },
          {
            path: ':id',
            element: <DeliveryOrderDetailPage />,
          },
        ],
      },
    ],
  },
];
